import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SessionInfo() {
  const { code } = useParams();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await axios.get(`${API}/sessions/by-code/${code}`);
        setSession(response.data);
      } catch (err) {
        setError('Sessao nao encontrada');
      } finally {
        setLoading(false);
      }
    };
    fetchSession();
  }, [code]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <Loader2 className="w-12 h-12 animate-spin text-blue-400" />
      </div>
    );
  }

  if (error || !session) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <p className="font-['Inter'] text-xl text-red-400">{error || 'Erro'}</p>
      </div>
    );
  }

  const joinUrl = `${BACKEND_URL}/join/${session.code}`;

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center" data-testid="session-info-page">
      <div className="text-center space-y-8 p-8">
        {/* Logo */}
        <img
          src="/logo-dih.png"
          alt="Do IT Happen"
          className="h-12 mx-auto opacity-70"
        />

        {/* Title */}
        <div>
          <h1 className="font-['Manrope'] text-2xl md:text-3xl font-bold text-white mb-2" data-testid="session-info-title">
            Traducao em Tempo Real
          </h1>
          <p className="font-['Inter'] text-base text-slate-400">
            Scan the QR code or enter the session code
          </p>
        </div>

        {/* QR Code */}
        <div className="flex justify-center">
          <div className="bg-white p-6 rounded-2xl shadow-2xl shadow-blue-500/10" data-testid="session-info-qr">
            <QRCodeSVG value={joinUrl} size={280} />
          </div>
        </div>

        {/* Session Code */}
        <div>
          <p className="font-['Inter'] text-sm text-slate-500 uppercase tracking-wider mb-2">
            Session Code
          </p>
          <p className="font-['JetBrains_Mono'] text-5xl md:text-7xl font-bold text-blue-400 tracking-widest" data-testid="session-info-code">
            {session.code}
          </p>
        </div>

        {/* Join URL */}
        <div>
          <p className="font-['Inter'] text-sm text-slate-500 uppercase tracking-wider mb-1">
            Join URL
          </p>
          <p className="font-['Inter'] text-lg text-slate-300" data-testid="session-info-url">
            {joinUrl}
          </p>
        </div>

        {/* Footer branding */}
        <p className="font-['Inter'] text-xs text-slate-600 pt-4">
          Powered by Do IT Happen
        </p>
      </div>
    </div>
  );
}
